/* eslint-disable react/jsx-no-target-blank */
import React from "react"
import { Button } from "../../components/common/button/Button"

export const BrowseStock: React.FC = () => {

  const BASE_URL = `${window.location.origin}`

  return (
    <a 
      className="text-link" 
      href={`${BASE_URL}/vehicle-search?Type=Car`}
      style={{
        width: "100%",
        maxWidth: "350px"
      }}
    >
			<Button type="button" variant="white" style={{ background: "none" }}>
				BROWSE OUR STOCK
			</Button>
		</a>
  )
}
